import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { Grid, Typography } from "@material-ui/core";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import Service from "./RegionService";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from "../../componentes/chip/DefaultChip";

const columnsState = (t) => [
    { field: "idState", visible: false },
    {
        field: "nmState",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="state" name="map" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.nmState}
                        </Typography>}
                    />
                </>
            )
        }

    },
    {
        field: "uf",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="uf" name="map" />;
        }, flex: 0.5
    },
    {
        field: "cdUF",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cdUF" name="map" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.cdUF}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "cdStatus",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

const RegionState = () => {
    const { t } = useTranslation();
    const { control } = useForm();

    const userId = sessionStorage.getItem("userId");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case 'clear':
                return initialStateRegistrationState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return state
        }
    }

    const initialStateRegistrationState = {
        idCountry: 0,
        idState: 0,
        nmState: "",
        uf: "",
        cdUF: "",
        status: 1,
        stateRows: [],
        idUser: userId,
        alertMessage: "",
        success: false,
        error: false
    };

    const [state, dispatch] = useReducer(reducer, initialStateRegistrationState)
    const { idState, idCountry, nmState, uf, cdUF, status, stateRows, alertMessage, success, error } = state



    const handleChange = ({ target: { name, value } }) => {

        if (name === 'cdUF') {
            if (value !== '' && !/^\d+$/.test(value)) {

                dispatch({
                    type: 'update',
                    data: { alertMessage: t("onlyNumber"), error: true, success: false }
                })
            }
            else {
                dispatch({
                    type: 'update',
                    data: {
                        [name]: value,
                        alertMessage: '', // limpa mensagem
                        error: false,
                        success: false
                    }
                });
            }
        }
        else {
            dispatch({
                type: 'update',
                data: { [name]: value }
            })
        }
    }

    const canSave = () => nmState;

    const handleSearchRegionState = () => {
        Service
            .getState(state)
            .then((response) => {
                dispatch({
                    type: 'update',
                    data: { stateRows: response.data }
                })
            })
            .catch((e) => { });
    };

    const handleClearRegionState = () => {
        dispatch({ type: 'clear' })
    };

    const saveRegionState = () => {
        if (canSave()) {
            const { stateRows, alertMessage, success, error, ...data } = state

            if (idState === 0) {
                Service
                    .createState(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idState > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionState();
                        }
                    })
                    .catch((e) => { });
            } else {
                Service
                    .updateState(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idState > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionState();
                        }
                    })
                    .catch((e) => { });
            }
        }
        else {
            dispatch({
                type: 'update',
                data: { alertMessage: t("checkFields"), error: true, success: false }
            })
        }
    };

    const selectedStateChanged = (data) => {
        dispatch({
            type: 'update',
            data: { idState: idState, ...data, }
        })
    };

    return (

        <DefaultScreenAccordion
            title={t("state")}
            isRegister
            fields={
                <>
                    <GridItemContainer>
                        <CustomAlert
                            message={alertMessage}
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <GridInputRow>
                            <Grid item xs={3}>
                                <DefaultAutocomplete
                                    name={"idCountry"}
                                    onChange={handleChange}
                                    placeholder={t("country")}
                                    label={t("country")}
                                    useApi
                                    endpoint='GetCountryAutocomplete'
                                    value={idCountry}
                                    defaultSize
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    iconLabelSwitch={<IconLabelSwitch fontSize="small" name="map" labelName="nmState" />}
                                    name="nmState"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={nmState}
                                    length={50}
                                    translationString={"state"}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <InputField
                                    iconLabelSwitch={<IconLabelSwitch fontSize="small" name="map" labelName="uf" />}
                                    name="uf"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={uf}
                                    length={50}
                                    translationString={"uf"}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <InputField
                                    iconLabelSwitch={<IconLabelSwitch fontSize="small" name="map" labelName="cdUF" />}
                                    name="cdUF"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={cdUF}
                                    length={4}
                                    translationString={"cdUF"}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <DefaultAutocomplete
                                    name={"status"}
                                    onChange={handleChange}
                                    value={status}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        { id: 1, name: t("active"), status: 1 },
                                        { id: 2, name: t("all"), status: 1 },
                                    ]}
                                    error={error && status === 2}
                                    placeholder={t("status")}
                                />
                            </Grid>
                        </GridInputRow>

                        <SearchClearSaveRow
                            onClickSearch={handleSearchRegionState}
                            onClickSave={saveRegionState}
                            onClickClear={handleClearRegionState}
                        />
                    </GridItemContainer>

                    {stateRows.length > 0 ? (
                        <DefaultDatagrid
                            dataSource={stateRows}
                            columns={columnsState(t)}
                            allowPaging={true}
                            cellSelected={(selected) => {
                                selectedStateChanged(selected.data);
                            }}
                        />
                    ) : null}
                </>
            } />
    );
};

export default RegionState;